














































































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { PressaoArterial } from '../../../../back/src/entity/PressaoArterial';
import {
  ApresentacaoFetal,
  PosicaoFetal,
  MovimentoFetal,
  Edema,
  TipoConsulta,
  TipoNotaProntuario,
} from '../../../../back/src/types';
import {
  apresentacaoFetalStrings,
  posicaoFetalStrings,
  movimentoFetalStrings,
  edemaStrings,
  tipoNotaProntuarioIcons,
  tipoNotasProntuarioStrings,
} from '../../utils/constants';

import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import TheConsultasDadosIndividual from './TheConsultasDadosIndividual.vue';
import NotasProntuarioDados from '../notas_prontuarios/NotasProntuarioDados.vue';
import NotasProntuarioForm from '../notas_prontuarios/NotasProntuarioForm.vue';
import ThePressoesArteriaisDadosDialog from '../pressoes_arteriais/ThePressoesArteriaisDadosDialog.vue';
import { calculoIdadeGestacional, calculaImc } from '../../utils/functions';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import { NotaProntuario } from '../../../../back/src/entity/NotaProntuario';
import { Paciente } from '../../../../back/src/entity/Paciente';
import ConsultasQueixasCondutasLer from './ConsultasQueixasCondutasLer.vue';

export default Vue.extend({
  name: 'ConsultasFinalizadasNotasProntuarioTabela',
  components: {
    CustomDialog,
    IfEmptyTextPrintNA,
    TheConsultasDadosIndividual,
    ThePressoesArteriaisDadosDialog,
    NotasProntuarioDados,
    NotasProntuarioForm,
    ConsultasQueixasCondutasLer,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    consultas: {
      type: Array as () => Consulta[],
    },
    notasProntuario: {
      type: Array as () => NotaProntuario[],
    },
  },
  data() {
    return {
      sortDesc: true,
      dialog: {
        notaProntuarioDados: false,
        consultaDados: false,
        pressaoArterial: false,
        consultaSelecionada: null,
        notaProntuarioSelecionada: null,
        pressaoArterialSelecionada: null,
        editarNotaProntuario: false,
      },
      TipoConsulta,
      tipoNotasProntuarioStrings,
      tipoNotaProntuarioIcons,
    };
  },
  computed: {
    headers() {
      return [
        {
          value: 'started',
          text: 'Data',
          class: 'text-no-wrap pl-2',
        },
        {
          value: 'tipo_consulta',
          text: 'Tipo',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        {
          value: 'ig',
          text: 'IG',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        {
          value: 'peso_gramas',
          text: 'Peso (kg)',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        {
          value: 'imc',
          text: 'IMC',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        {
          value: 'freq_card_materna',
          text: 'FC (bpm)',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        {
          value: 'pressoes_arteriais',
          text: 'PA (mmHg)',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'altura_uterina',
          text: 'AU (cm)',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'edema',
          text: 'Edema',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'movimento_fetal',
          text: 'MF',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'bat_card_fetal',
          text: 'BCF (bpm)',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'apres_fetal',
          text: 'Apresentação',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'posicao_fetal',
          text: 'Posição',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'responsavel',
          text: 'Responsável',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'info',
          text: 'Detalhes',
          class: 'text-no-wrap text-center',
        },
      ];
    },
    // eslint-disable-next-line camelcase
    consultasENotasSorted(): (any & { data_referencia: string }) {
      const itens = [];
      // eslint-disable-next-line camelcase
      const consultas: (any & { data_referencia: string }) = _.map(
        this.consultas,
        (el: Consulta) => ({ ...(el as Consulta), data_referencia: el.started }),
      );
      // eslint-disable-next-line camelcase
      const notas: (any & { data_referencia: string }) = _.map(
        this.notasProntuario,
        (el: NotaProntuario) => ({ ...el, data_referencia: el.data_nota }),
      );
      return _.orderBy(
        [...consultas, ...notas],
        ['data_referencia'],
        [this.sortDesc ? 'desc' : 'asc'],
      );
    },
  },
  methods: {
    calculaImc,
    onConsultaAlterada(consulta: Consulta) {
      this.dialog.consultaSelecionada = consulta;
      this.$emit('consulta-alterada', consulta);
    },
    notaProntuarioAlterada(notaAlterada: NotaProntuario) {
      this.$emit('nota-prontuario-alterada', notaAlterada);
      this.dialog.editarNotaProntuario = false;
      this.dialog.notaProntuarioDados = false;
      this.dialog.notaProntuarioSelecionada = null;
    },
    cancelarEdicaoNotaProntuario() {
      this.dialog.editarNotaProntuario = false;
    },
    stripedRow(index: number): string {
      if (Number(index) % 2 === 0) {
        return 'grey lighten-3';
      }
      return '';
    },
    linkConsultaColetiva(consultaColetivaId: number) {
      return {
        name: 'ConsultaColetivaAtiva',
        params: { consultaColetivaId },
      };
    },
    gemelar(gestacao: Gestacao) {
      return gestacao ? gestacao.gestacao_gemelar : false;
    },
    tipoNotaIcon(tipoNota: TipoNotaProntuario): string {
      if (_.has(tipoNotaProntuarioIcons, tipoNota)) {
        return tipoNotaProntuarioIcons[tipoNota];
      }
      return '';
    },
    idadeGestacional(consulta: Consulta): string {
      return calculoIdadeGestacional(consulta.gestacao, consulta.started);
    },
    pesoKg(pesoGramas: number): string {
      if (pesoGramas) {
        const pesoKg = pesoGramas / 1000;
        return new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 1,
        }).format(pesoKg);
      }
      return '';
    },
    edema(edema: Edema): string {
      if (_.has(edemaStrings, edema)) {
        return `${edemaStrings[edema]}/4+`;
      }
      return '';
    },
    apresentacaoFetal(apresentacaoFetal: ApresentacaoFetal): string {
      if (_.has(apresentacaoFetalStrings, apresentacaoFetal)) {
        return apresentacaoFetalStrings[apresentacaoFetal];
      }
      return '';
    },
    posicaoFetal(posicaoFetal: PosicaoFetal): string {
      if (_.has(posicaoFetalStrings, posicaoFetal)) {
        return posicaoFetalStrings[posicaoFetal];
      }
      return '';
    },
    movimentoFetal(movimentoFetal: MovimentoFetal): string {
      if (_.has(movimentoFetalStrings, movimentoFetal)) {
        return movimentoFetalStrings[movimentoFetal];
      }
      return '';
    },
    resultadosDeExames(
      resultadosDeExames: ResultadoDeExame[],
    ): ResultadoDeExame[] {
      return _.filter(
        resultadosDeExames as ResultadoDeExame[],
        resultado => !resultado.deleted,
      );
    },
    stringResultadosDeExames(resultadosDeExames: ResultadoDeExame[]): string {
      let string = '';
      _.forEach(
        this.resultadosDeExames(resultadosDeExames) as ResultadoDeExame[],
        (resultado) => {
          const nomeExame = resultado.exame
            ? resultado.exame.nome
            : resultado.nome_exame || '';
          string = `${string}${nomeExame.trim()}${
            resultado.observacoes ? ` (${resultado.observacoes.trim()})` : ''
          }, `;
        },
      );
      return string.substr(0, string.length - 2);
    },
    selecionaConsulta(consulta: Consulta) {
      this.dialog.consultaSelecionada = consulta;
      this.dialog.consultaDados = true;
    },
    selecionaNotaProntuario(notaProntuario: NotaProntuario) {
      this.dialog.notaProntuarioSelecionada = notaProntuario;
      this.dialog.notaProntuarioDados = true;
    },
    selecionaPressaoArterial(
      consulta: Consulta,
      pressaoArterial: PressaoArterial,
    ) {
      this.dialog.consultaSelecionada = consulta;
      this.dialog.pressaoArterialSelecionada = pressaoArterial;
      this.dialog.pressaoArterial = true;
    },
  },
});
